module.exports = __webpack_public_path__ + "static/media/graphql.32bc428f.svg";